import {
  Box,
  Collapse,
  Container,
  IconButton,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import DownIcon from "@mui/icons-material/ArrowDropDown";
import { collection, db, getDocs } from "../../firebaseConfig";

const FaqSection = () => {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleClickDropdown = (id) => {
    setActiveDropdown(activeDropdown === id ? null : id);
  };

  // Fetch data from Firestore when the component loads
  useEffect(() => {
    const fetchData = async () => {
      const querySnapshot = await getDocs(collection(db, "questions"));
      const questionList = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setQuestions(questionList);
      setLoading(false);
    };

    fetchData();
  }, []);

  const faqInfo = [
    {
      id: 1,
      question: "Live in a remote or overpopulate environment where schooling?",
      answer:
        "Lorem ipsum dolor sit amet consectetur. Neque enim aenean bibendum lobortis. Neque arcu senectus quam ac lacinia faucibus magna nam.",
    },
    {
      id: 2,
      question: "Live in a remote or overpopulate environment where schooling?",
      answer:
        "Lorem ipsum dolor sit amet consectetur. Neque enim aenean bibendum lobortis. Neque arcu senectus quam ac lacinia faucibus magna nam.",
    },
    {
      id: 3,
      question: "Live in a remote or overpopulate environment where schooling?",
      answer:
        "Lorem ipsum dolor sit amet consectetur. Neque enim aenean bibendum lobortis. Neque arcu senectus quam ac lacinia faucibus magna nam.",
    },
    {
      id: 4,
      question: "Live in a remote or overpopulate environment where schooling?",
      answer:
        "Lorem ipsum dolor sit amet consectetur. Neque enim aenean bibendum lobortis. Neque arcu senectus quam ac lacinia faucibus magna nam.",
    },
  ];

  return (
    <Box sx={{ width: "100vw" }}>
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",

          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography variant="h2" maxWidth={"350px"} my={4} textAlign={"center"}>
          Frequently <span style={{ color: "#DB5430" }}>Asked</span> Questions
        </Typography>
      </Container>
      <Container sx={{ mb: 20 }}>
        {questions.map((faq) => (
          <Box
            key={faq.id}
            sx={{
              width: "inherit",
              backgroundColor: "rgba(219, 84, 48, 0.4)",
              p: 2,
              borderRadius: 2,
              mb: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <Typography variant="body1" sx={{ fontWeight: "600" }}>
                {faq.question}
              </Typography>
              <IconButton
                aria-label="open"
                sx={{
                  transform:
                    activeDropdown === faq.id
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                  transition: "transform 0.3s ease",
                }}
                onClick={() => handleClickDropdown(faq.id)}
              >
                <DownIcon color="secondary" />
              </IconButton>
            </Box>
            <Collapse
              in={activeDropdown === faq.id}
              timeout="auto"
              unmountOnExit
            >
              <Box
                sx={{
                  mt: 2,
                  p: 2,
                  bgcolor: "white",
                  borderRadius: 1,
                  boxShadow: 2,
                }}
              >
                <Typography variant="body2">{faq.answer}</Typography>
              </Box>
            </Collapse>
          </Box>
        ))}
      </Container>
    </Box>
  );
};

export default FaqSection;
